import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslationObject } from '@app/core/models';
import { SnackBarComponent } from '@app/shared/components/snack-bar/snack-bar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  private readonly _matSnackBar = inject(MatSnackBar);

  openSnackBar(
    classPrefix: 'error' | 'success' | 'warning',
    messages?: TranslationObject[],
    title?: string,
    duration = 12000
  ): MatSnackBarRef<SnackBarComponent> {
    return this._matSnackBar.openFromComponent(SnackBarComponent, {
      duration,
      panelClass: [`${classPrefix}-snackbar`, 'am-snack-bar'],
      data: {
        title,
        messages,
        actionLabel: 'X',
      },
    });
  }
}
